import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { Store } from "@ngxs/store";
import { adminPermissions, MenuItem, OrganizationFeatures, Tag, TagFilter } from "@vp/models";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import * as TagsActions from "../state+/tags-actions";
import { TagsState } from "../state+/tags-state";
import { FeatureService } from "@vp/shared/features";

@Injectable()
export class FilteredTagsResolverService {
  private featureService = inject(FeatureService);
  private store = inject(Store);

  resolve(route: ActivatedRouteSnapshot): Tag[] | Observable<Tag[]> | Promise<Tag[]> {
    const tagFilter: Partial<TagFilter> = route.data?.tagFilter;
    const caseId = route.params["caseId"];
    if (caseId) {
      tagFilter.caseId = caseId;
    }
    return this.store
      .dispatch(new TagsActions.SetFiltered(tagFilter, false))
      .pipe(map(() => this.store.selectSnapshot(TagsState.filtered)));
  }

  resolvePageMenuItems(): Observable<MenuItem[]> {
    const importTagMenuItem: MenuItem = {
      label: "tagImportBreadcrumbButton",
      routerLink: "/administration/import-tags",
      permissions: [adminPermissions.Tags.Write]
    };

    return this.featureService
      .featureFlagEnabled$(OrganizationFeatures.tagManager, "enableTagImport")
      .pipe(
        take(1),
        map(enabled => (enabled ? [importTagMenuItem] : []))
      );
  }
}

export const FilteredTagsResolver: ResolveFn<Tag[]> = (
  route: ActivatedRouteSnapshot
): Tag[] | Observable<Tag[]> | Promise<Tag[]> => {
  return inject(FilteredTagsResolverService).resolve(route);
};

export const PageMenuItemsResolver: ResolveFn<MenuItem[]> = (): Observable<MenuItem[]> => {
  return inject(FilteredTagsResolverService).resolvePageMenuItems();
};
